import { render, staticRenderFns } from "./SectionHeading.vue?vue&type=template&id=298b88cf&functional=true&"
import script from "./SectionHeading.vue?vue&type=script&lang=ts&"
export * from "./SectionHeading.vue?vue&type=script&lang=ts&"
import style0 from "./SectionHeading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports